module.exports = __webpack_public_path__ + "static/media/pobal.6989272e.png";